import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logo from '../assets/images/logo.gif';
import sharkskillz from '../assets/images/sharkskillz.png';
import sharkskillz2 from '../assets/images/sharkskillz2.png';
import CustomSecondaryButton from '../components/globals/CustomSecondaryButton';
import CustomPrimaryButton from '../components/globals/CustomPrimaryButton';
import { useNavigate } from 'react-router-dom';
import { apiPost } from '../utils/Api';
import { ENDPOINTS } from '../utils/EndPoint';
import { v4 as uuidv4 } from 'uuid';
import { useRecoilState } from 'recoil';
import { isLoaderState, snakeBarState } from '../store/RecoilStore';
import { roleAtom, tokenAtom, userAtom } from '../store/authAtom';
import { setRoleLocal, setTokenLocal, setUserLocal } from '../utils/Session';


function Register() {
  const [stepForm, setStepForm] = useState(0);
  const [isLoaderInfo, setIsLoaderInfo] = useRecoilState(isLoaderState);
  const navigate = useNavigate();

  const [user, setUser] = useRecoilState(userAtom);
  const [role, setRole] = useRecoilState(roleAtom);
  const [token, setToken] = useRecoilState(tokenAtom);

  const [errMsg, setErrMsg] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);

  const getDeviceId = () => {
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem('device_id', deviceId);
    }
    return deviceId;
  };

  const guestUser = async () => {
    setIsLoaderInfo(true);

    let payload = {
      device_id: getDeviceId(),
      platform: 'web'
    };

    apiPost(
      ENDPOINTS.GuestUser,
      payload,
      (res) => {

        setUser(res.data.user_details)
        setToken(res.data.token)
        setUserLocal(res.data.user_details)
        setTokenLocal(res.data.token)

        setRoleLocal(res.data.user_details.roles[0]['name'])
        setRole(res.data.user_details.roles[0]['name'])

        setIsLoaderInfo(false);
        navigate("/welcome");
      },
      (err) => {
        console.log("err", err);
        setIsLoaderInfo(false);
      }
    );
  };

  useEffect(() => {
    const isGuestRegistered = localStorage.getItem('isGuestRegistered');
    if (isGuestRegistered === 'true') {
      navigate("/welcome");
    }
  }, [navigate]);
  return (
    <Container fluid className='p-0'>
      <Row className='g-0'>
        <Col md={12} lg={7}>
          <div className='join-shark'>
            <div className='inner-logo d-flex align-items-center pt-3'>
              <img src={logo} className='register-logo' />
              <img src={sharkskillz} className='logo-pic' />
            </div>
            <div className='inner-text'>
              <h2 className='text-white font-55'>
                Join SharkSkillz and unlock<br />
                your potential.
              </h2>
              <p className='text-white font-22 skranji-regular mt-4'>
                What if there was an App that taught you skillz to get rich - SharkSkillz, a dynamic web and mobile application compatible with both iOS, Android and Web browsers as well. Designed to empower schools and individuals alike, SharkSkillz is the ultimate platform for mastering essential skills in business, finance, cryptocurrency, artificial intelligence, and life skills.
              </p>
            </div>
          </div>
        </Col>
        <Col md={12} lg={5} className='register d-flex'>
          <div className='d-block mx-auto text-center align-self-center register-inner'>

            <img src={logo} className='register-pic' />

            <img src={sharkskillz2} className='register-pic mb-5' />

            <CustomSecondaryButton
              btnTextPro="Login"
              classNamePro="mb-4"
              handleOnClick={() => {
                navigate('/login');
              }}
            />

            <CustomSecondaryButton
              btnTextPro="Register"
              classNamePro="mb-4"
              handleOnClick={() => {
                navigate('/register-form');
              }}
            />

            <CustomPrimaryButton btnTextPro="Guest User" handleOnClick={() => {
              guestUser();
            }} />

          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default Register